module.exports = __webpack_public_path__ + "img/Row bungalow - Kolhapur.943ba6ed.jpg";